<div #outsideMap class="map-container map-collapsed"></div>